import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SplashScreen from './SplashScreen';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [showSplash, setShowSplash] = useState(false);
  const navigate = useNavigate();

  const handleDemoClick = () => {
    setShowSplash(true);
  };

  const handleSplashComplete = () => {
    setShowSplash(false);
    navigate('/dashboard');
  };

  return (
    <>
      <nav className="navigation">
        <div className="nav-container">
          <div className="nav-logo">
            <Link to="/">
              <img src={require('../assets/nrtr-logo.png')} alt="NRTR Logo" />
            </Link>
          </div>
          
          <div className="nav-menu">
            <div className="menu-item dropdown">
              <span>Features</span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M3 7.17L9 13.17L15 7.17" stroke="#3C403A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="menu-item dropdown">
              <span>Pricing</span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M3 7.17L9 13.17L15 7.17" stroke="#3C403A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="menu-item">
              <span>Support</span>
            </div>
          </div>

          <div className="nav-actions">
            <button className="btn-secondary" onClick={handleDemoClick}>Get a demo</button>
            <Link to="/login" className="btn-primary nav-link">
              Login
            </Link>
          </div>
        </div>
        <div className="nav-separator"></div>
      </nav>

      {/* Splash Screen */}
      {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
    </>
  );
};

export default Navigation; 